import './shared';

import 'lightgallery/dist/js/lightgallery-all';
import 'lightgallery/dist/css/lightgallery.css';

import './plugins/hash';
import './plugins/donation';

import '../styles/inner_index.css';

const _dir = $('html').attr('dir');
const _isRtl = (_dir === 'rtl');

((
    ($) => {
        $('.gallery').lightGallery({
            selector: '.gallery-item',
            share: false,
            useLeft: (_isRtl),
        });

        $('.single-video').each(function (index, video) {
            const _video = $(video);
            _video.lightGallery({
                share: false,
                useLeft: (_isRtl),
                galleryId: $(this).data('id'),
            });
        })


        $('.video-item').click(function () {
            $('.video-item--video').show(800);
            $('.video-item--title').hide(500);
            $('.video-item--icon').hide(500);
        });


        if (typeof (application.audio_url) != 'undefined') {
            const audioElement = document.createElement('audio');
            audioElement.setAttribute('src', application.audio_url);

            $('.js-play-audio').on('click', function () {
                const _btn = $(this);
                console.log(_btn)
                if (!_btn.hasClass('playing')) {
                    _btn.addClass('playing');
                    audioElement.play();
                    _btn.find('> .item').html('<i class="icon-pause"></i>');
                } else {
                    _btn.removeClass('playing');
                    audioElement.pause();
                    _btn.find('> .item').html('<i class="icon-play"></i>');
                }
            });
        }
    }
)
(jQuery));

docReady(() => {
    const _video = $('.inner-video');
    if (_video) {
        const _iframe = _video.find('> iframe');
        _iframe.attr('src', _iframe.data('src'));
    }

    let videoLoaded = false;
    const videoHeight = () => {
        $('.gallery-video').css('height', $('#gallery-image-first').css('height'));
    }

    document.addEventListener('lazyloaded', function (e) {
        if (!videoLoaded) {
            setTimeout(function () {
                videoHeight();
            }, 1000);
            videoLoaded = true;
        }
    });

    $(window).on('resize', function () {
        document.addEventListener('lazyloaded', function (e) {
            if (!videoLoaded) {
                setTimeout(function () {
                    videoHeight();
                }, 1000);
                videoLoaded = true;
            }
        });
    });

    let navText = ['<i class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'];
    if (_isRtl) {
        navText = ['<i class="icon-arrow-right"></i>', '<i class="icon-arrow-left"></i>'];
    }


    let targets = $('.js-lazyload');

    if (targets.length) {
        let options = {
            root: null,
            rootMargin: '0px',
            threshold: 0
        };

        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!$(entry.target).hasClass('activated')) {
                        if ($(entry.target).hasClass('sponsor-lazyload')) {
                            $('.owl-sponsor').owlCarousel({
                                rtl: _isRtl,
                                margin: 20,
                                dots: true,
                                loop: false,
                                items: 6,
                                autoplay: true,
                                slideTransition: 'ease',
                                autoplayTimeout: 3000,
                                autoplaySpeed: 1000,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');
                                },
                                responsive: {
                                    0: {
                                        items: 1,
                                    },
                                    330: {
                                        items: 2,
                                    },
                                    576: {
                                        items: 3,
                                    },
                                    700: {
                                        items: 4,
                                    },
                                    768: {
                                        items: 5,
                                    },
                                    1200: {
                                        items: 6,
                                    }
                                }
                            });
                        } else if ($(entry.target).hasClass('testimonials-lazyload')) {
                            $('.owl-testimonials').owlCarousel({
                                rtl: _isRtl,
                                margin: 0,
                                dots: true,
                                loop: false,
                                items: 1,
                                autoplay: true,
                                slideTransition: 'ease',
                                autoplayTimeout: 3000,
                                autoplaySpeed: 1000,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');
                                }
                            });
                        } else if ($(entry.target).hasClass('action-lazyload')) {
                            $('.owl-action').owlCarousel({
                                rtl: _isRtl,
                                margin: 0,
                                dots: true,
                                loop: false,
                                items: 1,
                                autoplay: true,
                                slideTransition: 'ease',
                                autoplayTimeout: 3000,
                                autoplaySpeed: 1000,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');
                                }
                            });
                        } else if ($(entry.target).hasClass('speakers-lazyload')) {
                            $('.owl-speakers').owlCarousel({
                                rtl: _isRtl,
                                margin: 20,
                                dots: true,
                                loop: false,
                                items: 5,
                                autoplay: true,
                                slideTransition: 'ease',
                                autoplayTimeout: 3000,
                                autoplaySpeed: 1000,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');
                                },
                                responsive: {
                                    0: {
                                        items: 1,
                                    },
                                    576: {
                                        items: 3,
                                    },
                                    768: {
                                        items: 4,
                                    },
                                    1200: {
                                        items: 5,
                                    }
                                }
                            });
                        } else if ($(entry.target).hasClass('winners-lazyload')) {
                            $('.owl-winners').owlCarousel({
                                rtl: _isRtl,
                                margin: 20,
                                dots: true,
                                loop: false,
                                items: 6,
                                autoplay: true,
                                slideTransition: 'ease',
                                autoplayTimeout: 3000,
                                autoplaySpeed: 1000,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');
                                },
                                responsive: {
                                    0: {
                                        items: 1,
                                    },
                                    330: {
                                        items: 2,
                                    },
                                    576: {
                                        items: 3,
                                    },
                                    700: {
                                        items: 4,
                                    },
                                    768: {
                                        items: 5,
                                    },
                                    1200: {
                                        items: 6,
                                    }
                                }
                            });
                        } else if ($(entry.target).hasClass('winners-content-lazyload')) {
                            $('.owl-winners-content').owlCarousel({
                                rtl: _isRtl,
                                margin: 20,
                                dots: false,
                                nav: true,
                                navText: navText,
                                loop: false,
                                items: 1,
                                autoplay: true,
                                lazyLoad: true,
                                lazyLoadEager: 1,
                                slideTransition: 'ease',
                                autoplayTimeout: 3000,
                                autoplaySpeed: 1000,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');
                                }
                            });
                        }
                    }
                }
            });
        }, options);

        targets.each(target => {
            observer.observe(targets[target]);
        });
    }

    $('.item8.winners').on('click', function (e) {
        const _btn = $(this);
        $(".owl-winners-content").trigger("to.owl.carousel", [_btn.data('index'), 1])
        $('.item19-w').removeClass('hide').addClass('open');
    });

    $('.item19-popup--close').on('click', function (e) {
        const _btn = $(this);
        _btn.closest('.item19-w').removeClass('open').addClass('hide');
    });

    $(document).click(function (e) {
        var $tgt = $(e.target);
        if ($tgt.hasClass("item19-w")) {
            $('.item19-w').removeClass('open').addClass('hide');
        }
    });

    $('.count').each(function () {
        $(this).prop('Counter', 0).animate({
            Counter: $(this).text()
        }, {
            duration: 4000,
            easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now));
            }
        });
    });
});